import { useMemo } from 'react';
import { useAgentRoutes } from './useAgentRoutes';
import staticRoutes from '../routes';

export const useDynamicRoutes = () => {
  const { agentRoutes, loading } = useAgentRoutes();

  const routes = useMemo(() => {
    if (loading) {
      return staticRoutes;
    }

    const hasAgents = agentRoutes.length > 0;

    const dynamicRoutes = staticRoutes.map(route => {
      // Find the Agents category and add dynamic agent subitems
      if (route.name === 'Agents' && route.category) {
        // Filter out "All Agents" if user already has agents
        const filteredItems = route.items.filter(item => {
          if (item.name === 'All Agents' && hasAgents) {
            return false; // Hide "All Agents" when agents exist
          }
          return true;
        });

        return {
          ...route,
          items: [
            ...filteredItems,
            ...agentRoutes
          ]
        };
      }
      return route;
    });
    
    return dynamicRoutes;
  }, [agentRoutes, loading]);

  return { routes, loading };
};
